import { Disclosure } from "@headlessui/react";
import { BlockWrapper } from "../Preview";
import React from "react";
import { generateCss, generateContent, generateStyle, generateEvent } from "../../functions/sortableFunctions";

const DisclosureButton = ({ block, ...props }: any) => {

    return (
        <React.Fragment>
            {
                React.createElement(
                    Disclosure.Button,
                    {
                        ...block.data,
                        style: generateStyle({
                            props: {
                                ...props,
                                block
                            }
                        }),
                        className: generateCss({
                            props: {
                                ...props,
                                block: block
                            }
                        }),
                        id: block.id,
                        as: block.data?.type ? block.data.type : 'div',
                        onClick: block.events?.onClick ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onClick"
                            });
                        } : null,
                        onDoubleClick: block.events?.onDoubleClick ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onDoubleClick"
                            });
                        } : null,
                        onContextMenu: block.events?.onContextMenu ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onContextMenu"
                            });
                        } : null,
                        onMouseOver: block.events?.onMouseOver ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onMouseOver"
                            });
                        } : null,
                        onMouseLeave: block.events?.onMouseLeave ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onMouseLeave"
                            });
                        } : null
                    },
                    block.children ?
                        block.children.map((value: any, index: any) => {
                            return <BlockWrapper
                                {...props}
                                key={index}
                                block={value}
                            />
                        })
                        :
                        generateContent({
                            props: {
                                ...props,
                                block: block
                            }
                        })
                )
            }
        </React.Fragment>
    )
}

export default DisclosureButton;